import liveDealer from 'assets/images/awards/live-dealer-games-medal.svg';
import membersChoice from 'assets/images/awards/members-choice-medal.svg';
import { DOMAINS } from 'helpers/constants';

export const awardsImages = [
  {
    src: liveDealer,
    alt: 'live dealer',
  },
  {
    src: membersChoice,
    alt: 'members choice',
  },
];

export const ALLOWED_DOMAINS = [DOMAINS.MAIN, DOMAINS.LOCAL, DOMAINS.DEV];
